module.exports = __webpack_public_path__ + "static/img/14.bc8a3a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/14.png
// module id = ZVk0
// module chunks = 0